import { MAX_PDF_FILE_SIZE, MAX_PDF_TOTAL_SIZE } from "./constants";

export const validateAnalysisUploadFiles = (
  files: ReadonlyArray<Pick<File, "name" | "size">>
): string | null => {
  const pdfCount = files.filter((file) =>
    file.name.toLowerCase().endsWith(".pdf")
  ).length;
  const zipCount = files.filter((file) =>
    file.name.toLowerCase().endsWith(".zip")
  ).length;
  if (pdfCount + zipCount !== files.length) {
    return "PDFまたはZIPファイルを選択してください";
  }
  if (pdfCount > 0 && zipCount > 0) {
    return "PDFとZIPは同時に選択できません";
  }
  if (zipCount > 1) {
    return "ZIPファイルは1つだけ選択してください";
  }
  if (pdfCount > 100) {
    return "PDFは100件まで選択できます";
  }
  if (pdfCount > 0 && files.some((file) => file.size > MAX_PDF_FILE_SIZE)) {
    return "PDFは1ファイル25MB以下にしてください";
  }
  if (
    pdfCount > 0 &&
    files.reduce((total, file) => total + file.size, 0) > MAX_PDF_TOTAL_SIZE
  ) {
    return "PDFの合計サイズは250MB以下にしてください";
  }
  return null;
};
